import { required } from '@jfs/ui-new'
import { TextInputNew } from '../../../../../components/AdminInputs'
import { styles } from './styles'
export const tidDetails = (isEditMode: boolean) => [
  {
    actionTitle: 'Proceed',
    key: 'tidDetails',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'mid',
            ComponentName: TextInputNew,
            label: 'Merchant ID',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles().textinputStyle(isEditMode),
            testID: 'mid',
          },
          {
            fieldName: 'tid',
            ComponentName: TextInputNew,
            label: 'Terminal ID',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles().textinputStyle(isEditMode),
            testID: 'tid',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'terminalType',
            ComponentName: TextInputNew,
            label: 'Terminal Type',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles().textinputStyle(isEditMode),
            testID: 'terminalType',
          },
          {
            fieldName: 'mobile',
            ComponentName: TextInputNew,
            label: 'Mobile No',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles().textinputStyle(isEditMode),
            testID: 'mobile',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'nickName',
            ComponentName: TextInputNew,
            label: 'Nick Name',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles().textinputStyle(isEditMode),
            testID: 'nickName',
          },
          {
            fieldName: 'issueRefund',
            ComponentName: TextInputNew,
            label: 'Issue Refund',
            editable: isEditMode,
            placeholder: '',
            validationSchema: isEditMode ? required : undefined,
            ...styles().textinputStyle(isEditMode),
            testID: 'issueRefund',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'acceptPayment',
            ComponentName: TextInputNew,
            label: 'Accept Payment',
            editable: isEditMode,
            placeholder: '',
            validationSchema: isEditMode ? required : undefined,
            ...styles().textinputStyle(isEditMode),
            testID: 'acceptPayment',
          },
          {
            fieldName: 'sodexoFlag',
            ComponentName: TextInputNew,
            label: 'Sodexo Flag',
            editable: isEditMode,
            placeholder: '',
            validationSchema: isEditMode ? required : undefined,
            ...styles().textinputStyle(isEditMode),
            testID: 'sodexoFlag',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'cashNCarry',
            ComponentName: TextInputNew,
            label: 'Cash & Carry',
            editable: isEditMode,
            placeholder: '',
            validationSchema: isEditMode ? required : undefined,
            ...styles().textinputStyle(isEditMode),
            testID: 'cashNCarry',
          },
          {
            fieldName: 'vpa',
            ComponentName: TextInputNew,
            label: 'VPA',
            editable: isEditMode,
            placeholder: '',
            validationSchema: isEditMode ? required : undefined,
            ...styles().textinputStyle(isEditMode),
            testID: 'vpa',
          },
        ],
        horizontalSpacing: 8,
      },
      //   {
      //     horizontalComps: [
      //       {
      //         fieldName: 'acceptPayment',
      //         ComponentName: TextInputNew,
      //         label: 'Accept Payment',
      //         editable: isEditMode,
      //         placeholder: '',
      //         validationSchema: isEditMode ? required : undefined,
      //         ...styles().textinputStyle(isEditMode),
      //         testID: 'acceptPayment',
      //       },
      //       {
      //         fieldName: 'acceptUPI',
      //         ComponentName: TextInputNew,
      //         label: 'Accept UPI',
      //         editable: isEditMode,
      //         placeholder: '',
      //         validationSchema: isEditMode ? required : undefined,
      //         ...styles().textinputStyle(isEditMode),
      //         testID: 'acceptUPI',
      //       },
      //     ],
      //     horizontalSpacing: 8,
      //   },
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]
